import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31597ee3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray" }
const _hoisted_2 = {
  key: 1,
  class: "row w-100 m-0 p-0"
}
const _hoisted_3 = { class: "col-md-10 pt-5" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { key: 0 }

import HeaderAdmin from '@/components/header/admin/index.vue'
import Footer from '@/components/footer-admin/index.vue'
import { ROOT_STORE } from '@/store/constants'
import { computed, ComputedRef, onMounted, ref, watch } from 'vue'
import Membership from '@/components/membership/index.vue'
import AsideAdmin from '../aside-admin/index.vue'
import { useRoute, useRouter } from 'vue-router'
import InquiryForm from '@/views/user/users/inquiry/form-inquiry/index.vue'
import registerService from '@/services/register-alumnus.service'
import communityServices from '@/services/communities.service'
import { CommunityStateTypes } from '@/store/modules/community'
import { COMMUNITY_STORE } from '@/store/constants'
import { useStore } from 'vuex'


const __default__ = {
  name: 'LayoutSidebarAdmin',
}

function setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const dataMembership = ref({})
const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])
const checkRouteNotAuth = route.path.includes('users/login') || route.path.includes('/community/account/profile/edit')

onMounted(async () => {
  checkAdmin()
})

const checkAdmin = async () => {
  try {
    const routerCurrent = router.currentRoute.value.path.split('/')
    if (routerCurrent[1] === 'community' && routerCurrent[2] === 'communities') {
      const communityRes = await communityServices.getCommunity()
      await store.dispatch(COMMUNITY_STORE.ACTIONS.GET_ALL_COMMUNITIES, communityRes?.data)
      if (!me.value) {
        await store.dispatch(COMMUNITY_STORE.ACTIONS.SET_ME, { id: route.params?.id, type: 'users' })
      }
      const isAdmin = communityRes.data.data.filter((item: any) => item.id === me.value?.community_id)[0]?.admin
      if (!isAdmin) router.push(`/${router.currentRoute.value.path.split('/')[1]}/lobby`)
    }
  } catch (error) {
    console.log(error)
  }
}
watch(
  () => route.path,
  () => {
    checkAdmin()
  }
)

const ShowMembership = async (): void => {
  try {
    const response = await registerService.getTermsOfServicesYelloopApi('employee')
    if (response?.status === 200) dataMembership.value = response?.data?.data
  } catch (error) {
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderAdmin, { ShowMembership: ShowMembership }),
    _createElementVNode("section", _hoisted_1, [
      (_unref(route).meta?.hideSidebar)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(['col-md-2', !_unref(isMobile) ? 'aside' : ''])
            }, [
              _createVNode(AsideAdmin)
            ], 2),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createVNode(Footer, { ShowMembership: ShowMembership })
            ])
          ]))
    ]),
    (!_unref(route)?.params?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(Footer)
        ]))
      : _createCommentVNode("", true),
    (!_unref(checkRouteNotAuth))
      ? (_openBlock(), _createBlock(InquiryForm, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(Membership, {
      data: dataMembership.value,
      title: 'admin'
    }, null, 8, ["data"])
  ], 64))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})